export default __webpack_public_path__ + "static/media/elocution.37470b23.png";